export default {
      id: "rim-1-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#rim-1",
      toString: function () {
        return this.url;
      }
    }